<template>
    <div class="registration">
        <div>
            <div class="block registration-service">
                <md-card v-if="withDiscovery" class="service-card demo-card">
                    <md-card-header>
                        <h2 v-html="$t('registration.service-discovery')"></h2>
                    </md-card-header>
                    <md-card-content class="service-card-content">
                        <div class="service-card-subtitle">
                            <div class="primary-text" v-html="$t('registration.service-demo-description', {days: days})"></div>
                            <div class="sub-text">{{ $t('registration.service-demo-description-precision') }}</div>
                        </div>
                        <div class="service-card-icon">
                            <img src="/imgs/loupe.svg" />
                        </div>
                        <submit-button
                            class="md-raised md-primary md-theme-default registration-standalone-button"
                            @click="submit('demo')"
                            :label="$t('registration.service-discover')"
                            :submitting="submittingDiscovery"
                            :disabled="isSubmiting"
                        />
                    </md-card-content>
                </md-card>
                <md-card class="service-card with-billing-card">
                    <md-card-header>
                        <h2>{{ $t('registration.service-join') }}</h2>
                        <div class="service-card-subtitle">
                            {{ $t('registration.service-join-subscription') }}
                        </div>
                    </md-card-header>
                    <md-card-content v-if="withBilling" class="service-card-content" style="height:100%;">
                        <div class="service-card-content-split">
                            <div class="service-card-element service-card-border">
                                <div class="service-card-subtitle">
                                    <div class="primary-text">{{ $t('registration.service-join-now') }}</div>
                                    <div class="sub-text">{{ $t('registration.service-join-now-precision') }}</div>
                                </div>
                                <div class="service-card-icon">
                                    <img src="/imgs/cb.svg" />
                                </div>
                                <submit-button
                                    class="md-raised md-primary md-theme-default registration-standalone-button"
                                    @click="submit('payment')"
                                    :label="$t('registration.service-pay-now')"
                                    :submitting="submittingPayNow"
                                    :disabled="isSubmiting"
                                />
                            </div>
                            <div class="service-card-element">
                                <div class="service-card-subtitle">
                                    <div class="primary-text" v-html="$t('registration.service-join-bill')"></div>
                                    <div class="sub-text">{{ $t('registration.service-join-bill-precision') }}</div>
                                </div>
                                <div class="service-card-icon">
                                    <img src="/imgs/billing.svg" />
                                </div>
                                <submit-button
                                    class="md-raised md-primary md-theme-default registration-standalone-button"
                                    @click="submit('bill')"
                                    :label="$t('registration.service-pay-bill')"
                                    :submitting="submittingPayBill"
                                    :disabled="isSubmiting"
                                />
                            </div>
                        </div>
                    </md-card-content>
                    <md-card-content v-else class="service-card-content">
                        <div class="service-card-subtitle">
                            <div class="primary-text">{{ $t('registration.service-join-now') }}</div>
                            <div class="sub-text">{{ $t('registration.service-join-now-precision') }}</div>
                        </div>
                        <div class="service-card-icon">
                            <img src="/imgs/cb.svg" />
                        </div>
                        <submit-button
                            class="md-raised md-primary md-theme-default registration-standalone-button"
                            @click="submit('payment')"
                            :label="$t('registration.service-pay-now')"
                            :submitting="submittingPayNow"
                            :disabled="isSubmiting"
                        />
                    </md-card-content>
                </md-card>
                <span class="hint-text select-service-hint" v-html="getPrice" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        days: String,
        withBilling: {
            type: Boolean,
            default: false
        },
        withDiscovery: {
            type: Boolean,
            default: false,
        },
        isProfessional: {
            type: Boolean,
            required: true,
        }
    },
    data() {
        return {
            submittingDiscovery: false,
            submittingPayNow: false,
            submittingPayBill: false,
            isSubmiting: false,
        };
    },
    computed: {
        getPrice() {
            const key = this.isProfessional ? 'without' : 'with';

            return this.$t(`registration.service-hint-${key}-vat`);
        }
    },
    methods: {
        submit(type) {
            this.submiting(type, true);
            axios.post('/registration/select-service', {registration_type: type}).then((response) => {
                if (response['status'] == 'ok') {
                    window.location = response.data['redirect'];
                } else {
                    this.submiting(type, false);
                }
            }).watch((error) => {
                this.submiting(type, false);
            });
        },
        submiting(type, value) {
            if (type === 'demo') {
                this.submittingDiscovery = value;
            } else if (type === 'payment') {
                this.submittingPayNow = value; 
            } else if (type === 'bill') {
                this.submittingPayBill = value;
            }
            this.isSubmiting = value;
        }
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/registration/SelectServiceComponent.vue